PJQ.files = {
    downloadDrawings: function (attachments, project, options) {
        let objType = PJQ.helpers.objectHelpers.refinedType(attachments, true);
        if (objType === 'backboneCollection' || objType === 'array') {
            let versions = {},
                versionIds = _.uniq(_.map(_.filter(objType === 'array' ? attachments : attachments.models, function (attachment) {
                    return attachment.get("isDrawing") && attachment.get('guid') != null;
                }), function (attachment) {
                    return attachment.get('versionId');
                }));
            _.each(versionIds, function (versionId) {
                versions[versionId] = _.map(_.filter(objType === 'array' ? attachments : attachments.models, function (attachment) {
                    return attachment.get('versionId') === versionId
                }), function (drawing) {
                    return drawing.get('guid');
                });
            });

            let params = [];
            if (options) {
                if (options.raster) {
                    params.push({
                        parameter: 'raster',
                        value: options.raster
                    });
                }
                if (options.merge) {
                    params.push({
                        parameter: 'merge',
                        value: options.merge
                    });
                }

                if (options.includeAttachments) {
                    params.push({
                        parameter: 'attachments',
                        value: options.includeAttachments
                    });
                }
            }

            let endpoint;
            if (project != null) {
                endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: project.id
                    },
                    {
                        endpoint: 'drawings'
                    },
                    {
                        endpoint: 'downloads'
                    }
                ], params)
            } else {
                endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'drawings'
                    },
                    {
                        endpoint: 'downloads'
                    }
                ], params)
            }
            let data = {
                versions: versions,
                fileGuids: _.map(_.filter(objType === 'array' ? attachments : attachments.models, function (attachment) {
                    return !attachment.get("isDrawing");
                }), function (attachment) {
                    return attachment.get('guid');
                })
            };
            PJQ.files.queueDownload(endpoint, data);
        } else {
            new PJQ.models.drawings.Drawing({
                drawingId: -attachments.get('entryId'),
                guid: attachments.get('guid')
            }).download();
        }
    },
    queueDownload: function (endpoint, data, downloadStartCallback, isApiv2 = false) {
        PJQ.files.createDownloadFrame();
        let req = new PJQ.ajax.Request({
            endpoint: endpoint,
            data: data,
            isApi2: true,
            isAPIv2: isApiv2
        });
        if (data != null) {
            req = req.post();
        } else {
            req = req.get();
        }
        req.done(_.bind(function (download) {
            if (typeof downloadStartCallback === 'function') {
                downloadStartCallback();
            }
            this.handleDownload(download);
        }, this)).fail(function (jqXHR) {
            PJQ.files.logDownloadFailure({
                endpoint: endpoint,
                error: jqXHR.responseText
            });
        });
    },
    handleDownload: function (download) {
        let minWaitSeconds;
        let showPromo;
        let promoType = 'fora'
        // force a minimum wait for downloads on projects that they don't own or when the user is not logged in
        if (PJQ.app.session && PJQ.app.session.get('portalId') === PJQ.constants.panteraPortalId && PJQ.app.options.isPanteraApp &&
            (PJQ.app.session.user == null
                || (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')))) {
            let contact = PJQ.app.session.contact,
                groupIds = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.QUIKBID_GROUP_IDS);
            // Make groupids an array
            if (groupIds != null) {
                groupIds = groupIds.split(",");
                // Fetch contact if contact isn't fetched. Rerun handleDownload after they are fetched
                if (contact != null && !contact.isFetched) {
                    contact.fetch({
                        success: _.bind(function () {
                            this.handleDownload(download);
                        }, this)
                    })
                    return;
                }
                // Check if any of the the contacts groups match the specified quikbids groups.
                if (contact != null) {
                    _.each(contact.groups.models, function (group) {
                        let quikBidGroup = _.contains(groupIds, group.get('groupId').toString());
                        if (quikBidGroup) {
                            promoType = 'quikbid';
                        }
                    }, this);
                }
            }
            minWaitSeconds = 20;
            showPromo = true;
        } else {
            minWaitSeconds = null;
            showPromo = false;
        }
        if (download.isReady && download.url && (!(download.isZip || download.isDrawing) || minWaitSeconds <= 0 || minWaitSeconds == null)) {
            PJQ.files.downloadFile(download.url, {
                isEndpoint: false
            });
        } else {
            if (download.isZip) {
                new PJQ.views.files.ZipProgressModal({
                    model: new PJQ.models.files.ZipFile(download),
                    minWaitSeconds: minWaitSeconds,
                    showPromo: showPromo,
                    promoType: promoType
                });
            } else if (download.isDrawing) {
                new PJQ.views.files.DrawingProgressModal({
                    model: new PJQ.models.drawings.DrawingDownload(download),
                    minWaitSeconds: minWaitSeconds,
                    showPromo: showPromo,
                    promoType: promoType
                });
            } else {
                new PJQ.views.files.FileProgressModal({
                    model: new PJQ.models.files.File(download)
                });
            }
        }
    },
    logDownloadFailure: function (data) {
        new PJQ.logging.Debug(PJQ.logging.LoggingActions.FILE_DOWNLOAD_FAILED, data);
    },
    downloadFile: function (url, options = {}) {
        PJQ.files.createDownloadFrame();
        if (options.isEndpoint !== false) {
            options.includeSessionId = true;
            options.includeAccessToken = true;
            if (options.isAPIv2 === true) {
                options.service = PJQ.constants.services.APIv2;
            } else if (options.isApi2 === true) {
                options.service = PJQ.constants.services.FILES;
            }
            url = PJQ.helpers.urlHelpers.buildApiUrl(url, options);
        }
        window.open(url, PJQ.constants.files.downloadFrameId);
    },
    createDownloadFrame: function () {
        let iFrame = $('#' + PJQ.constants.files.downloadFrameId);
        if (_.size(iFrame) === 0) {
            iFrame = $('<iframe/>', {
                id: PJQ.constants.files.downloadFrameId,
                name: PJQ.constants.files.downloadFrameId,
                class: 'hidden'
            });
            $('body').append(iFrame);
        }
        return iFrame;
    }
};

//Models
PJQ.models.files = {};
PJQ.models.files.File = PJQ.models.BaseModel.extend({
    idAttribute: 'entryId',
    endpointArr: function () {
        let arr;
        if (this.get('isFolder')) {
            if (_.size(this.get('guid')) > 0) {
                arr = [
                    {
                        endpoint: 'files',
                        value: this.get('guid')
                    }
                ];
            } else {
                arr = [
                    {
                        endpoint: 'folders',
                        value: this.get('folderGuid')
                    }
                ];
            }
        } else {
            if (_.size(this.get('guid')) > 0) {
                if (this.get('entryId') < 0) {
                    arr = [
                        {
                            endpoint: 'drawings',
                            value: this.get('guid')
                        }
                    ];
                } else {
                    arr = [
                        {
                            endpoint: 'files',
                            value: this.get('guid')
                        }
                    ];
                }
            } else if (_.size(this.get('key')) > 0) {
                arr = [
                    {
                        endpoint: 'files',
                        value: this.get('key')
                    }
                ];
            } else {
                arr = [
                    {
                        endpoint: 'files',
                        value: this.get('entryId')
                    }
                ];
            }
        }
        return arr;
    },
    endpoint: function (urlOptions) {
        let params;
        if (urlOptions != null && urlOptions.params != null) {
            params = urlOptions.params;
        } else {
            params = [];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(this.endpointArr(), params);
    },
    renderUrl: function (pageNumber) {
        //currently returns renderid as a fallback for old places that only have the entryid and not the guid
        return PJQ.helpers.urlHelpers.buildAPIURL(PJQ.helpers.urlHelpers.generateEndpoint(_.union(this.endpointArr(), [{
                endpoint: _.size(this.get('guid')) > 0 ? 'render' : 'renderid'
            }]),
            [
                {
                    parameter: 'pageNumber',
                    value: pageNumber > 0 ? pageNumber : 1
                }
            ]), false, false, true);
    },
    urlForKey: function (key) {
        return PJQ.helpers.urlHelpers.buildApiUrl(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files',
                value: _.size(key) > 0 ? key : this.get('key')
            }
        ]), {
            service: PJQ.constants.services.APIv2
        });
    },
    thumbnailUrl: function () {
        let thumbUrl = this.get('thumbUrl');
        if (_.size(thumbUrl) > 0) {
            return thumbUrl;
        } else {
            if (_.size(this.get('key')) > 0) {
                return this.urlForKey() + '/thumbnail';
            }
            return this.dataUrl;
        }
    },
    getSize() {
        if (this.get('isFolder')) {
            return _.reduce(this.getFolderAttachments(), function (memo, file) {
                return memo + file.getSize();
            }, 0);
        } else {
            return this.get('size');
        }
    },
    exportFileList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files',
                value: this.get('entryId')
            },
            {
                endpoint: 'export'
            }
        ]));
    },
    addNotification: function (email) {
        new PJQ.models.files.DrawingNotification({
            guid: this.get('guid'),
            email: email
        }).save();
    },
    download: function () {
        let url = this.get('url');
        if (_.size(url) === 0 && _.size(this.get('key')) > 0) {
            url = this.urlForKey() + '/download';
        }

        if (_.size(url) > 0) {
            PJQ.files.downloadFile(url, {
                isEndpoint: false,
                isApi2: true
            });
        } else if (_.size(this.get('guid')) > 0) {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint(this.endpointArr()) + '/download', {
                isApi2: true
            });
        }
    },
    move: function (files, options, callback) {
        let params = [];
        if (options.project != null) {
            params.push({
                parameter: "projectId",
                value: options.project.id
            });
        }
        // move files to this folder
        if (this.get('isFolder')) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'files',
                        value: this.get('entryId')
                    },
                    {
                        endpoint: 'moveto'
                    }
                ], params),
                data: {
                    entryList: _.map(files, function (file) {
                        return file.get('entryId')
                    })
                }
            }).put().done(_.bind(function (changedFiles) {
                _.each(changedFiles, function (changedFile) {
                    let matchFile = _.find(files, function (file) {
                        return file.get('entryId') === changedFile.entryId;
                    });
                    if (matchFile != null) {
                        matchFile.set('folderId', changedFile.folderId);
                    }
                }, this);
                callback(files);
            }, this));
        } else {
            callback(files);
        }
    },
    copy: function (files, options, callback) {
        let params = [];
        if (options.project != null) {
            params.push({
                parameter: "projectId",
                value: options.project.id
            });
        }
        // move files to this folder
        if (this.get('isFolder')) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'files',
                        value: this.get('entryId')
                    },
                    {
                        endpoint: 'copyto'
                    }
                ], params),
                data: {
                    entryList: _.map(files, function (file) {
                        return file.get('entryId')
                    })
                }
            }).put().done(_.bind(function (newFiles) {
                callback(newFiles);
            }, this));
        } else {
            callback(files);
        }
    },
    destroy: function (options) {
        if (this.get('isFolder')) {
            this.deleteFolderContents();
        }
        return Backbone.Model.prototype.destroy.call(this, options);
    },
    deleteFolderContents: function () {
        _.each(this.getFolderAttachments(), _.bind(function (file) {
            if (file.get('isFolder')) {
                file.deleteFolderContents();
            }
            if (this.collection != null) {
                this.collection.remove(file);
            }
        }, this));
    },
    detachFromProject: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'attachments',
                    value: this.get('guid')
                },
                {
                    endpoint: 'detach'
                }
            ])
        }).delete().done(callback);
    },
    parse: function (model) {
        if (model != null) {
            if (model.key != null) {
                model.url = this.urlForKey(model.key) + "/download";
                model.thumbUrl = this.urlForKey(model.key) + "/thumbnail";
            }

            if (model.createdOn != null) {
                model.createdOn = new Date(model.createdOn);
            }

            if (model.versions != null) {
                this.versions = new PJQ.collections.files.Files(model.versions);
            }
        }
        return model;
    },
    convert: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint(this.endpointArr()) + '/convert',
            isApi2: true
        }).post().done(callback).fail(_.bind(function () {
            PJQ.files.logDownloadFailure({
                file: this,
                error: "Failed to convert file"
            })
        }, this));
    },
    checkStatus: function (callback) {
        new PJQ.ajax.Request({
            url: this.get('url')
        }).get().done(callback).fail(_.bind(function () {
            PJQ.files.logDownloadFailure({
                file: this,
                error: "Failed to process file"
            })
        }, this));
    },
    canRender: function () {
        let extension = PJQ.helpers.fileHelpers.getExtension(this.get("name"));
        return extension === 'pdf' || extension === 'tiff' || extension === 'tif';
    },
    isImage: function () {
        return _.contains(PJQ.constants.files.imageExtensions, PJQ.helpers.fileHelpers.getExtension(this.get("name")));
    },
    getNameNoExtension: function () {
        return this.get('name').replace(this.getExtension(), '');
    },
    getExtension: function () {
        let ext = this.get('name').split('.').pop();
        return ext === "" ? ext : ('.' + ext);
    },
    icon: function (isColored = false) {
        let icon;
        if (this.get('isFolder')) {
            icon = 'folder';
        } else {
            icon = 'file';
            switch (PJQ.helpers.fileHelpers.getExtension(this.get("name"))) {
                case 'avi':
                case 'mp4':
                case 'flv':
                case 'mov':
                case 'qt':
                case 'wmv':
                case 'webm':
                    icon = 'file-video';
                    break;
                case 'mp3':
                case 'wav':
                case 'flac':
                case 'm4a':
                case 'm4b':
                case 'wma':
                case 'aac':
                case 'aiff':
                    icon = 'file-audio';
                    break;
                case 'png':
                case 'jpg':
                case 'jpeg':
                case 'bmp':
                case 'gif':
                case 'tif':
                case 'tiff':
                    icon = 'file-image';
                    break;
                case 'pdf':
                    icon = 'file-pdf';
                    break;
                case 'xls':
                case 'xlsx':
                    icon = 'file-excel';
                    break;
                case 'doc':
                case 'docx':
                    icon = 'file-word';
                    break;
                case 'ppt':
                case 'pptx':
                    icon = 'file-powerpoint';
                    break;
                case 'csv':
                    icon = 'file-csv';
                    break;
                case 'zip':
                case 'rar':
                case '7z':
                case 'gz':
                case 'tar':
                    icon = 'file-archive';
                    break;
                case 'eml':
                case 'mbox':
                case 'msg':
                    icon = 'envelope';
                    break;
            }
        }
        return (isColored ? 'file-type ' : '') + 'fal fa-' + icon;
    },
    getFolderAttachments: function (isRecursive = false, filter) {
        return this.collection.getFolderAttachments(this, isRecursive, filter);
    },
    fetchFolderAttachments: function (options = {recursive: false}, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'files'
                }
            ], [
                {
                    parameter: 'folderId',
                    value: this.get('guid')
                },
                {
                    parameter: 'recursive',
                    value: options && options.recursive
                }
            ])
            //isApi2: true //dont do this yet
        }).get().done(_.bind(function (files) {
            if (this.collection != null) {
                this.collection.add(files, {
                    silent: true
                });
            }
            this.isFetched = true;
            callback(this.collection.get(_.map(files, function (file) {
                return file.entryId;
            })));
        }, this)).fail(_.bind(function (xhr, err, result) {
            callback(null);
        }, this));
    },
    getSiblingAttachments: function () {
        let folderId = this.get('folderId');
        if (this.collection == null || !(folderId > 0)) {
            return [this];
        }

        return this.collection.where({folderId: folderId});
    },
    getParentFolder: function (recursive = false, contextFolder = null, folders = null) {
        let folderId = this.get('folderId');
        if (recursive) {
            if (contextFolder != null) {
                folderId = contextFolder.get('folderId');
            }

            if (folders == null) {
                folders = [];
            }

            if (folderId != null) {
                let parentFolder = this.collection.findWhere({
                    entryId: folderId
                });
                if (parentFolder != null) {
                    folders.push(parentFolder);
                    return this.getParentFolder(recursive, parentFolder, folders);
                }
            }
            return folders;
        }

        if (this.collection == null) {
            return null;
        }

        return this.collection.findWhere({
            entryId: folderId
        });
    },
    getDepth: function () {
        if (this.collection == null) {
            return 0;
        }

        let folder = this.getParentFolder(),
            depth = 0;
        while (folder != null) {
            depth++;
            folder = folder.getParentFolder();
        }
        return depth;
    }
});

PJQ.models.files.ZipFile = PJQ.models.files.File.extend({
    idAttribute: "guid",
    endpoint: function () {
        if (PJQ.app.options.isV2Zips) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'zips',
                    value: this.get('guid')
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files'
            },
            {
                endpoint: 'zips',
                value: this.get('guid')
            }
        ]);
    },
    beforeInit: function (options) {
        if (PJQ.app.options.isV2Zips) {
            options.isAPIv2 = true;
        }
    },
    downloadEndpoint: function () {
        return this.endpoint() + '/download';
    },
    download: function () {
        let url = this.get('url');
        if (_.size(url) === 0 && _.size(this.get('key')) > 0) {
            url = this.urlForKey() + '/download';
        }

        if (_.size(url) > 0) {
            PJQ.files.downloadFile(url, {
                isEndpoint: false,
                isApi2: true,
                isAPIv2: PJQ.app.options.isV2Zips
            });
        } else {
            PJQ.files.queueDownload(this.endpoint(), {guids: this.get('guids')}, null, PJQ.app.options.isV2Zips)
        }
    },
    addNotification: function (email) {
        new PJQ.models.files.ZipFileNotification({
            guid: this.get('guid'),
            email: email
        }).save();
    },
    cancel: function () {
        if (!this.get('isReady')) {
            this.set('status', PJQ.constants.files.zipStatus.CANCELLED);
            new PJQ.ajax.Request({
                endpoint: this.endpoint('cancel')
            }).delete();
        }
    }
});

PJQ.models.files.ZipFileNotification = PJQ.models.BaseModel.extend({
    idAttribute: 'zipFileNotificationId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files'
            },
            {
                endpoint: 'zips',
                value: this.get('guid')
            },
            {
                endpoint: 'notifications'
            }
        ]);
    }
});

PJQ.models.files.DrawingNotification = PJQ.models.BaseModel.extend({
    idAttribute: 'notificationId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'downloads',
                value: this.get('guid')
            },
            {
                endpoint: 'notifications'
            }
        ]);
    }
});

//Collections
PJQ.collections.files = {};

PJQ.collections.files.Files = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.files.File,
    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
        {
            endpoint: 'files'
        }
    ], [
        {
            parameter: 'folderId',
            value: this.options ? this.options.folderId : null
        }
    ]),
    share: function (data, project, callback) {
        let endpoint;
        if (project != null) {
            if (this.options.isPhotos) {
                endpoint = "/projects/" + project.id.toString() + "/photos/share";
            } else {
                endpoint = "/projects/" + project.id.toString() + "/attachments/share";
            }
        } else {
            endpoint = "/files/share";
        }
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                subject: data != null ? data.subject : null,
                emails: data != null ? data.emails : null,
                guids: _.map(this.models, function (model) {
                    return model.get('guid');
                })
            }
        }).post().done(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }).fail(function () {
            callback();
        });
    },
    download: function () {
        let hasDrawings = _.find(this.models, function (attachment) {
            return attachment.get('isDrawing');
        }) != null;
        if (hasDrawings) {
            PJQ.files.downloadDrawings(this.models);
        } else {
            new PJQ.models.files.ZipFile({
                guids: _.map(this.models, function (file) {
                    return file.get('guid')
                })
            }).download();
        }
    },
    getRootAttachments: function () {
        return this.where({folderId: 0});
    },
    getSharedFolder: function () {
        let sharedFolderRoot = this.get(-1);
        if (sharedFolderRoot == null) {
            let rootFolder = new PJQ.models.files.File({
                entryId: -1,
                folderId: 0,
                name: 'Shared',
                isFolder: true
            });
            this.add(rootFolder);
            _.each(this.models, _.bind(function (model) {
                if (model.get('entryId') !== -1 && null == _.find(this.models, function (modelComp) {
                    return modelComp.get('entryId') === model.get('folderId');
                })) {
                    model.set('folderId', -1);
                }
            }, this));
        }

        return _.find(this.models, function (model) {
            return model.get('folderId') === 0 && model.get('entryId') === -1;
        });
    },
    getPrivateFolder: function () {
        return _.find(this.models, function (model) {
            return model.get('folderId') === 0 && model.get('entryId') > 0;
        });
    },
    getRootSharedAttachments: function () {
        let sharedFolders = this.where({folderId: 0});
        if (_.size(sharedFolders) > 1) {
            return sharedFolders
        }
        let result = [];
        _.each(sharedFolders, function (sharedFolder) {
            result.push(...this.getFolderAttachments(sharedFolder));
        }, this);
        return result;
    },
    fetchFoldersAttachments: function (folders, options = {recursive: false}, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'files'
                }
            ], [
                {
                    parameter: 'folderIds',
                    value: _.map(_.filter(folders, function (folder) {
                        return folder.get('isFolder');
                    }), function (f) {
                        return f.get('guid');
                    })
                },
                {
                    parameter: 'recursive',
                    value: options && options.recursive
                }
            ])
            //isApi2: true //dont do this yet
        }).get().done(_.bind(function (files) {
            this.add(files, {
                silent: true
            });
            callback(this.get(_.map(files, function (file) {
                return file.guid;
            })));
        }, this)).fail(_.bind(function (xhr, err, result) {
            callback(null);
        }, this));
    },
    getFolderAttachments: function (folder, isRecursive = false, filter = {hideFiles: false, hideFolders: false}) {
        if (folder == null || !folder.get('isFolder')) {
            return [];
        }

        if (isRecursive) {
            let result = [];
            _.each(this.where({folderId: folder.get('entryId')}), function (attachment) {
                if (attachment.get('isFolder')) {
                    if (!filter.hideFolders) {
                        result.push(attachment);
                    }

                    result = _.union(result, this.getFolderAttachments(attachment, isRecursive, filter));
                } else if (!filter.hideFiles) {
                    result.push(attachment);
                }
            }, this);
            return result;
        } else {
            let where = {
                folderId: folder.get('entryId')
            };
            if (filter.hideFolders)
                where.isFolder = true;
            else if (filter.hideFiles) {
                where.isFolder = false;
            }

            return this.where(where);
        }
    },
    destroy: function (callback) {
        let privateFolder = this.getPrivateFolder(),
            privateFolderId = privateFolder ? privateFolder.get('entryId') : null,
            models = _.filter(this.models, _.bind(function (model) {
                return model.get('entryId') !== privateFolderId;
            }, this));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'files'
                }
            ]),
            data: {
                entryList: _.map(models, function (model) {
                    return model.get('entryId')
                })
            },
        }).delete().done(_.bind(function () {
            callback(true);
        }, this)).fail(_.bind(function () {
            callback(false);
        }, this));
    }
});

PJQ.collections.files.FileShare = PJQ.collections.files.Files.extend({
    model: PJQ.models.files.File,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'files'
            },
            {
                endpoint: 'share',
                value: this.options.accessKey
            }
        ]);
    }
});

//Views
PJQ.views.files = {};

PJQ.views.files.FileUploader = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader'),
        endpoint: "/files",
        canUpload: true,
        canDelete: true,
        dictRemoveFile: "Delete",
        isRemoveOnComplete: false,
        ignoreHiddenFiles: false,
        allowedExtensions: null,
        dictDefaultMessage: "Drop files here or click to upload",
        parallelUploads: 2,
        chunking: true,
        onError: _.noop,
        onSuccess: _.noop,
        onDrop: _.noop,
        useFileAPI: true,
        useApiV2: false,
        uuid: null
    },
    events: {
        'click .download-import-template': 'downloadImportTemplate'
    },
    downloadImportTemplate: function (e) {
        e.stopPropagation();

        if (typeof this.options.uploadTemplateCallback === 'function') {
            this.options.uploadTemplateCallback();
        }
    },
    getUrl: function (files) {
        let svc, endpoint;
        if (this.options.useApiV2) {
            svc = PJQ.constants.services.APIv2;
            endpoint = '/uploads';
        } else if (this.options.useFileAPI) {
            svc = PJQ.constants.services.FILES;
            endpoint = this.options.endpoint;
        } else {
            svc = PJQ.constants.services.API;
            endpoint = this.options.endpoint;
        }

        let result = PJQ.helpers.urlHelpers.buildApiUrl(endpoint, {
            service: svc
        });
        result += (result.indexOf('?') === -1 ? "?" : "&") + "folder=" + this.options.uuid;
        // there should only ever be one file in the files array
        if (_.size(files) === 1) {
            let file = files[0];
            if (_.size(file.fullPath) > 0 && file.fullPath !== file.name) {
                let folderPath = file.fullPath.replace('/' + file.name, '');
                if (_.size(folderPath) > 0) {
                    result += ('&fp=' + encodeURIComponent(folderPath));
                }
            }
        }
        return result;
    },
    beforeRender: function () {
        if (this.options.uuid === null)
            this.options.uuid = PJQ.helpers.guid();

        if (this.collection == null) {
            this.collection = new PJQ.collections.files.Files();
        }
    },
    renderData: function () {
        return {
            options: this.options,
            collection: this.collection,
            uuid: "fileUpload_" + this.options.uuid
        };
    },
    afterRender: function () {
        if (!this.options.canDelete)
            this.options.dictRemoveFile = "";
        this.options.headers = PJQ.helpers.apiHelpers.getHeaders();

        let acceptedFilesFormatted = _.map(this.options.allowedExtensions, function (extension) {
            return '.' + extension.toLowerCase();
        });
        this.options.dropzoneOptions = _.defaults(this.options, {
            url: _.bind(this.getUrl, this),
            hiddenInputContainer: this.$el[0],
            maxFilesize: 15000,
            acceptedFiles: _.size(acceptedFilesFormatted) > 0 ? acceptedFilesFormatted.join(',') : null
        });

        this.renderDropzone();

        if (this.options.canUpload) {
            let hasUploadTemplateCallback = typeof this.options.uploadTemplateCallback === 'function';
            let $footer = $('<div class="mt-1" />');
            this.$el.append($footer);

            if (_.size(this.options.allowedExtensions) > 0) {
                $footer.append($('<span>', {
                    class: 'text-muted fs-12 ml-1'
                }).append('<strong>Allowed File Types: </strong>' + this.options.allowedExtensions.join(',') + ((this.options.maxFiles || hasUploadTemplateCallback) ? ' |' : '')));
            }

            if (this.options.maxFiles) {
                $footer.append($('<span>', {
                    class: 'text-muted fs-12 ml-1'
                }).append('<strong>Max Files: </strong>' + this.options.maxFiles + (hasUploadTemplateCallback ? ' |' : '')));
            }

            if (hasUploadTemplateCallback) {
                $footer.append($('<span>', {
                    class: 'text-muted fs-12 ml-1'
                }).append('<strong>Upload Template: </strong>' + '<a class="download-import-template" href="javascript:void(0)">Download</a>'));
            }
        }
    },
    renderDropzone() {
        if (this.$('#fileUpload_' + this.options.uuid).length > 0) {
            this.dropzone = new Dropzone('#fileUpload_' + this.options.uuid, this.options.dropzoneOptions);
            this.dropzone.on('complete', _.bind(function (file) {
                if (this.options.isRemoveOnComplete) {
                    this.removeFile(file);
                }
                if (file.status === 'success') {
                    this.onSuccess(file);
                } else if (file.status === 'error') {
                    if (_.size(this.options.dropzoneOptions.acceptedFiles) > 0 && !_.contains(this.options.dropzoneOptions.acceptedFiles, function (extension) {
                        return file.name.toLowerCase().indexOf(extension);
                    })) {
                        this.removeFile(file);
                        this.showError('The file type you uploaded is not allowed');
                    }

                    this.onError(file);
                }
            }, this));
            this.dropzone.on('drop', _.bind(function () {
                if (typeof this.options.onDrop === 'function') {
                    this.options.onDrop();
                }
            }, this));
        }
    },
    showError: function (errorText, timeout = 2000) {
        this.errorAlert = new PJQ.Alert(this.$('.file-upload'), {
            type: 'danger',
            extraClasses: ['dropzone-error-alert', 'p-absolute', 'wd-100', 'left-0', 'text-align-center'],
            style: 'bottom:-13px !important;',
            text: errorText,
            isAppend: true,
            animation: {
                in: 'fadeIn',
                out: 'fadeOut'
            },
            timeout: timeout
        });

        return this.errorAlert;
    },
    isUploading: function () {
        return this.dropzone != null && _.size(this.dropzone.getQueuedFiles()) + _.size(this.dropzone.getUploadingFiles()) > 0;
    },
    clearError: function () {
        if (this.errorAlert != null) {
            this.errorAlert.destroy();
        }
    },
    removeFile: function (file) {
        if (this.dropzone != null) {
            this.dropzone.removeFile(file);
        }

        if (this.collection != null && file.model != null) {
            this.collection.remove(file.model);
        }
    },
    onError: function (data) {
        this.options.onError(data);
    },
    onSuccess: function (data) {
        let res = JSON.parse(data.xhr.response);
        res.name = res.fileName ?? res.name;
        this.options.onSuccess(res, data);
    }
});

PJQ.views.files.FileUploaderGrid = PJQ.views.files.FileUploader.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-Grid'),
        subTemplates: {
            gridFile: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-Grid-File'),
            listFile: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-List-File')
        },
        style: 'grid',
        sideBySide: false,
        isSmall: false, //this is used when the uploader is in a small location so the elements/text sizes need to be smaller
        endpoint: "/files",
        canUpload: true,
        canDelete: true,
        canView: true,
        dictRemoveFile: "Delete",
        isRemoveOnComplete: false,
        ignoreHiddenFiles: false,
        allowedExtensions: null,
        dictDefaultMessage: "Drop files here or click to upload",
        canDownloadAll: false,
        includeProjectAttachments: false,
        parallelUploads: 1,
        chunking: true,
        offsetTopText: false,
        onError: _.noop,
        onSuccess: _.noop,
        onFileStatusChange: _.noop,
        onDrop: _.noop,
        onDelete: null, //this must be null or correctly use the callback (2nd param)
        afterDelete: _.noop,
        previewImageDimension: 150,
        showCreatedByLink: true,
        useFileAPI: true,
        useApiV2: false,
        hasNotes: false,
        isVersioned: false,
        onNewVersion: _.noop,
        context: null,
        contextId: null,
        onAnnotationChange: null,
        canAddAnnotations: true,
        mergeAnnotations: null,
        sortDirection: 'desc',
        maxFiles: null,
        onNoteChanged: null
    },
    events: {
        'click .file-preview-image': 'viewFile',
        'click .file-view-pdf': 'viewPdfFile',
        'click .file-preview-download': 'downloadFile',
        'click .file-preview-delete': 'deleteFile',
        'click .btn-versions': 'viewFileVersions',
        'click .file-edit-note': 'editNote',
        'click .download-all': 'downloadAll',
        'click .dz-upload-project-attachments': 'uploadFromProjectAttachments',
        'click .download-import-template': 'downloadImportTemplate'
    },
    viewFileVersions: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        if (file == null && this.options.isVersioned) {
            // Find the model in the collection the versioned file belongs to
            file = _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        return true;
                    }
                }
                return false;
            });
        }

        new PJQ.views.files.FileVersionsModal({
            model: file,
            collectionDefinition: this.collection ? this.collection.constructor : null,
            onSave: _.bind(function (files) {
                let parentAttachment = files[0].get('parentAttachmentId') != null ? this.collection.get(files[0].get('parentAttachmentId')) : null;

                if (parentAttachment != null) {
                    parentAttachment.versions.add(files);
                }

                this.collection.add(files);
                if (this.options.onNewVersion) {
                    this.options.onNewVersion();
                }
            }, this)
        });
    },
    beforeFirstRender: function () {
        this.options.uuid = PJQ.helpers.guid();

        let prefs = null;
        if (PJQ.app.session.project != null) {
            prefs = PJQ.app.session.project.preferences;
        } else if (PJQ.app.session != null) {
            prefs = PJQ.app.session.preferences;
        }
        if (prefs != null) {
            this.options.sideBySide = prefs.hasPref(PJQ.constants.preferenceTypes.FILE_UPLOADER_SIDE_BY_SIDE);
        }
    },
    renderDropzone() {
        if (this.options.isSmall) {
            this.$('.file-upload').addClass('file-upload-small');
        }

        if (this.options.style.toLowerCase() === 'list') {
            this.$('.file-upload').addClass('file-upload-list');
        } else {
            this.$('.file-upload').addClass('file-upload-grid');
        }

        if (this.options.canUpload) {
            this.dropzone = new Dropzone(this.$('#fileUpload_' + this.options.uuid)[0], _.extend(this.options.dropzoneOptions, {
                maxFiles: this.options.maxFiles,
                maxfilesexceeded: _.bind(function (file) {
                    this.removeFile(file);
                    this.showError('Maximum files exceeded');
                }, this),
                addedfile: _.bind(function (file) {
                    if (this.options.maxFiles && _.size(_.filter(this.collection.models, function (model) {
                        return !model.get('delete') && !model.get('isDeleted');
                    }, this)) >= this.options.maxFiles) {
                        this.removeFile(file);
                        this.showError('Maximum files exceeded');
                        return;
                    }
                    let fileModel = new this.collection.model({
                        name: file.name,
                        status: 'queued'
                    });

                    if (PJQ.app.session.contact != null) {
                        fileModel.set('createdBy', PJQ.app.session.contact.toJSON());
                    } else if (PJQ.app.session.user != null) {
                        fileModel.set('createdBy', PJQ.app.session.user.toJSON());
                    }

                    if (this.options.versionByName) {
                        let parentAttachment;
                        if (typeof this.options.getParentAttachment === 'function') {
                            parentAttachment = this.options.getParentAttachment(fileModel);
                        } else {
                            parentAttachment = _.find(this.collection.models, (file) => {
                                return file.get('name') === fileModel.get('name') && !file.get('delete')
                                    && (file.get('parentAttachmentId') == null || file.get('parentAttachmentId') === file.id);
                            });
                        }
                        if (parentAttachment != null) {
                            fileModel.set('parentAttachmentId', parentAttachment.id);
                        }
                    }

                    fileModel.file = file;
                    file.model = fileModel;
                    this.collection.add(fileModel);
                    file.$previewElement = this.renderFile(fileModel, this.options.style.toLowerCase() === 'grid');
                    file.$previewElement.addClass('uploading queued');
                    file.previewElement = file.$previewElement[0];
                }, this),
                thumbnail: function (file, dataUrl) {
                    if (file.$previewElement != null) {
                        file.$previewElement.find('.file-preview-image').attr('src', dataUrl);
                    }
                },
                uploadprogress: function (file, progress) {
                    file.$previewElement.removeClass('queued');

                    if (file.model.get('status') !== file.status) {
                        file.model.set('status', file.status);
                        this.options.onFileStatusChange(file);
                    }

                    //This is a fix for chunking progress
                    //Dropzone triggers a progress event for the end of a chunk w/ a progress of 100%
                    //We want to ignore all progress events that are not related to the total upload progress of this file
                    if ((file.status === 'uploading' && progress < 100) || file.status === 'success') {
                        file.lastProgress = Math.ceil(progress);
                        let width = file.lastProgress.toString() + '%';
                        file.$previewElement.find(".file-preview-progress .progress-bar").css('width', width).html(width);
                    }
                },
                drop: _.bind(function () {
                    if (typeof this.options.onDrop === 'function') {
                        this.options.onDrop();
                    }
                }, this),
                complete: _.bind(function (file) {
                    file.model.set('status', file.status);
                    this.options.onFileStatusChange(file);
                    if (file.status === 'success') {
                        file.$previewElement.removeClass('uploading').addClass('uploaded');

                        file.model.dataUrl = file.dataURL;
                        let response = JSON.parse(file.xhr.response);
                        if (this.options.useApiV2 || (this.options.endpoint !== '/files' && !this.options.useApiV2)) {
                            file.model.set({
                                uploadId: response.uploadId,
                                name: response.name ?? response.fileName ?? response.fileData?.fileName
                            }, {
                                silent: true
                            });
                        } else {
                            file.model.set({
                                folder: response.folder,
                                name: response.name ?? response.fileName ?? response.fileData?.fileName
                            }, {
                                silent: true
                            });
                        }

                        if (!this.options.useApiV2 && this.options.endpoint !== '/files') {
                            let fileResponse;
                            if (PJQ.helpers.objectHelpers.refinedType(response) === 'array') {
                                _.each(response, function (responseFile) {
                                    if (responseFile.isFolder) {
                                        this.collection.add(responseFile);
                                    } else {
                                        fileResponse = responseFile;
                                    }
                                }, this);
                            } else {
                                fileResponse = response;
                            }
                            file.model.set(fileResponse, {
                                silent: true
                            });
                        }

                        if (file.model.id > 0) {
                            file.$previewElement.find('.file-preview-download').removeClass('hidden');
                        }

                        this.onSuccess(file);
                    } else if (file.status === 'error') {
                        if (_.size(this.options.dropzoneOptions.acceptedFiles) > 0 && !_.contains(this.options.dropzoneOptions.acceptedFiles, function (extension) {
                            return file.name.toLowerCase().indexOf(extension);
                        })) {
                            this.removeFile(file);
                            this.showError('The file type you uploaded is not allowed');
                        } else {
                            let retries = file.model.get('retries');
                            retries = retries != null ? retries : 0;
                            if (retries > -1) {
                                file.$previewElement.removeClass('uploading').addClass('failed');
                            } else {
                                file.model.set('retries', 1);
                                new File([file], file.name, {type: file.type});
                                this.dropzone.uploadFile(file);
                            }
                        }

                        this.onError(file);
                    }
                }, this)
            }));

        }

        this.renderFiles();
    },
    renderFiles() {
        if (this.options.canUpload) {
            this.renderUploadMessage();
        }

        _.each(_.sortBy(_.filter(this.collection.models, function (model) {
            return !model.get('isDeleted');
        }), _.bind(function (model) {
            if (this.options.sortBy)
                return model.get(this.options.sortBy);

            if (this.options.sortDirection && this.options.sortDirection.toLowerCase() === 'asc') {
                return model.id;
            }
            return -model.id;
        }, this)), _.bind(function (model) {
            let fileToRender = model;

            // If the model is versioned, we want to render the newest version.
            if (this.options.isVersioned) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    fileToRender = _.max(model.versions.models, (v) => v.get('version'));
                } else if (model.get('version') > 1) {
                    fileToRender = null;
                }
            }

            if (fileToRender != null) {
                this.renderFile(fileToRender);
            }
        }, this));
        PJQ.app.lazyLoad().update();
    },
    renderFile(file, isPrepend = false) {
        let fileTemplate;
        if (this.options.style.toLowerCase() === 'list') {
            fileTemplate = this.options.subTemplates.listFile;
        } else {
            fileTemplate = this.options.subTemplates.gridFile;
        }
        let $fileEl = PJQ.templating.TemplateRenderer.parseTemplate(fileTemplate, {
            model: file,
            showCreatedByLink: this.options.showCreatedByLink,
            canDelete: this.options.canDelete,
            canView: this.options.canView,
            isImage: file.isImage(),
            thumbUrl: file.thumbnailUrl(),
            previewImageDimension: this.options.previewImageDimension,
            hasNotes: this.options.hasNotes,
            isVersioned: this.options.isVersioned,
            versions: this.options.versions ? this.options.versions : null
        });
        if (this.options.canUpload && !this.$('.dz-message').hasClass('dz-message-top')) {
            $fileEl.addClass('hidden');
            this.renderUploadMessage(_.bind(function () {
                $fileEl.removeClass('hidden');
            }, this));
        }
        let $outer;
        if (this.options.sideBySide && file.id > 0) {
            $outer = this.$('.files-existing-container');
        } else {
            $outer = this.$('.files-container');
        }
        if (isPrepend) {
            $outer.prepend($fileEl);
        } else {
            $outer.append($fileEl);
        }
        return $fileEl;
    },
    renderUploadMessage: function (callback = _.noop) {
        let $message = this.$('.dz-message'),
            topClass = 'dz-message-top',
            topCSS = {
                height: '40px'
            };

        if (this.options.offsetTopText)
            topCSS.right = '3rem';

        if ((!this.options.sideBySide && this.collection.length > 0) || (this.collection.findWhere(function (attachment) {
            return attachment.isNew();
        }) != null)) {
            this.$('.file-upload').removeClass('dz-clickable');
            if (!$message.hasClass('dz-message-top')) {
                $message.addClass(topClass).animate(topCSS, 500, _.bind(function () {
                    $message.css(topCSS).html('Drop files or <a href="javascript:void(0)" class="file-upload-upload ml-1 text-orange">click here to upload</a>');
                    if (this.options.offsetTopText) {
                        $message.removeAttr('left')
                        $message.css('right', '3rem');
                    }
                    if (callback != null) {
                        callback();
                    }
                }, this)).addClass(topClass);
            } else {
                callback();
            }
        } else {
            $message.html('Drop files or click to upload');
            if (callback != null) {
                callback();
            }
        }
    },
    uploadFromProjectAttachments: function (e) {
        new PJQ.views.projects.AttachmentsModal({
            onSave: _.bind(function (files) {
                _.each(files, function (file) {
                    let fileModel = new PJQ.models.files.File(file.toJSON());
                    if (!fileModel.get('isFolder')) {
                        if (fileModel.get('drawingId') > 0) {
                            fileModel.set('entryId', -fileModel.get('drawingId'));
                        }
                        fileModel.set('attachmentId', null);
                        this.collection.add(fileModel);
                        this.options.onSuccess(fileModel);
                    }
                }, this)
                this.render();
            }, this)
        });
    },
    viewFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        // Find and set file to the newest version if the file is versioned.
        if (file == null && this.options.isVersioned) {
            _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        file = versionFile;
                        return true;
                    }
                }
                return false;
            });
        }

        PJQ.app.view.renderPhotoViewer({
            model: file,
            collection: this.collection,
            canDelete: this.options.canDelete,
            onDelete: _.bind(function () {
                this.render()
            }, this)
        });
    },
    viewPdfFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        // Find and set file to the newest version if the file is versioned.
        if (file == null && this.options.isVersioned) {
            _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        file = versionFile;
                        return true;
                    }
                }
                return false;
            });
        }

        if (file.get('entryId') < 0) {
            let drawing = new PJQ.models.drawings.Drawing({
                drawingId: -file.get('entryId')
            });
            drawing.fetch({
                success: _.bind(function () {
                    new PJQ.views.drawings.DrawingViewer({
                        model: drawing,
                        context: this.options.context,
                        contextId: this.options.contextId,
                        isAnnotationsEnabled: true,
                        noNavigation: true,
                        canAddAnnotations: this.options.canAddAnnotations,
                        onAnnotationChange: this.options.onAnnotationChange,
                        mergeAnnotations: this.options.mergeAnnotations != null ? this.options.mergeAnnotations.models : null
                    });
                }, this)
            })
        } else {
            new PJQ.views.files.FileViewer({
                model: file
            });
        }
    },
    downloadFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        // Find and set file to the newest version if the file is versioned.
        if (file == null && this.options.isVersioned) {
            _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        file = versionFile;
                        return true;
                    }
                }
                return false;
            });
        }

        if (file.versions != null && _.size(file.versions.models) > 0) {
            let newestVersion = file.versions.sortBy((v) => {
                return -v.id;
            })[0];
            return newestVersion.download();
        }
        file.download();
    },
    downloadAll: function () {
        this.collection.download();
    },
    downloadVersion: function (e) {
        let file = this.options.versions.get($(e.currentTarget).closest('.btn-download-version').data('cid'))
        file.download();
    },
    editNote: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));

        // Find the collection model the version belongs to. Keep all notes on the collection model.
        if (file == null && this.options.isVersioned) {
            file = _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        return true;
                    }
                }
                return false;
            });
        }

        new PJQ.views.submittals.FileEditorModal({
            model: file,
            isNoteEdit: true,
            collection: this.collection,
            isNewVersion: true,
            onSave: () => {
                this.render();

                if (typeof this.options.onNoteChanged === 'function') {
                    this.options.onNoteChanged(file);
                }
            }
        });
    },
    deleteFile: function (e) {
        let previewContainer = $(e.currentTarget).closest('.file-preview'),
            file = this.collection.get(previewContainer.data('cid'));

        // Find the collection model the version file belongs to and delete that.
        if (file == null && this.options.isVersioned) {
            file = _.find(this.collection.models, function (model) {
                if (model.versions != null && _.size(model.versions.models) > 0) {
                    let versionFile = model.versions.get($(e.currentTarget).closest('.file-preview').data('cid'));
                    if (versionFile != null) {
                        return true;
                    }
                }
                return false;
            });
        }

        if (typeof this.options.onDelete === 'function') {
            this.options.onDelete(file, _.bind(function () {
                previewContainer.remove();
                this.options.afterDelete();
            }, this));
        } else {
            file.destroy();
            previewContainer.remove();
            this.options.afterDelete();
        }
    }
});

PJQ.views.files.ZipProgressModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Zip-Progress'),
        subTemplates: {
            content: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Zip-Progress-Content')
        },
        checkProgressInterval: 2000,
        minWaitSeconds: null
    },
    events: {
        'click .zip-download-button': 'downloadZip',
        'click .zip-email-button': 'emailZip',
        'keyup .zip-email': 'emailChanged',
        'click .zip-cancel-button': 'cancelZip'
    },
    beforeModalCreated: function () {
        if (this.options.minWaitSeconds > 0) {
            this.isWaiting = true;
            this.waitTimeout = setTimeout(_.bind(function () {
                this.isWaiting = false;
                let status = this.model.get('status');
                if (this.model.get('isReady') && (status === PJQ.constants.files.zipStatus.COMPLETE || status === PJQ.constants.files.zipStatus.COMPLETE_ASYNC)) {
                    this.downloadZip();
                    this.stopChecking();
                }
            }, this), this.options.minWaitSeconds * 1000);
        }
    },
    renderData: function () {
        return {
            model: this.model,
            showPromo: this.options.showPromo,
            promoType: this.options.promoType
        };
    },
    afterRender: function () {
        this.renderContent();
        this.checkZipStatus();
    },
    checkZipStatus: function () {
        let status = this.model.get('status');
        if (this.model.get('isReady') && (status === PJQ.constants.files.zipStatus.COMPLETE || status === PJQ.constants.files.zipStatus.COMPLETE_ASYNC)) {
            if (this.isWaiting) {
                this.renderContent();
            } else {
                this.downloadZip();
            }
        } else if (status === PJQ.constants.files.zipStatus.NEW || status === PJQ.constants.files.zipStatus.QUEUED || status === PJQ.constants.files.zipStatus.IN_PROGRESS) {
            this.checkStatusTimeout = setTimeout(_.bind(function () {
                this.model.fetch({
                    success: _.bind(function () {
                        this.checkZipStatus();
                    }, this),
                    fail: _.bind(function (model, result) {
                        this.model.set('status', PJQ.constants.files.zipStatus.FAILED);
                        this.renderContent();
                        PJQ.files.logDownloadFailure({
                            model: model,
                            result: result
                        });
                    }, this)
                });
            }, this), this.options.checkProgressInterval);
        } else if (status === PJQ.constants.files.zipStatus.CANCELLED || status === PJQ.constants.files.zipStatus.FAILED) {
            this.renderContent();
        }
    },
    renderContent: function () {
        let defaultEmail = "";
        if (PJQ.app.session.user != null) {
            defaultEmail = PJQ.app.session.user.get('email');
        } else if (PJQ.app.session.contact != null) {
            defaultEmail = PJQ.app.session.contact.get('email');
        }
        this.renderSubTemplate(false, this.options.subTemplates.content, this.$('.download-content'), {
            model: this.model,
            defaultEmail: defaultEmail,
            isWaiting: this.isWaiting
        }, _.bind(function () {
            if (this.model.get('status') === PJQ.constants.files.zipStatus.CANCELLED || this.model.get('status') === PJQ.constants.files.zipStatus.FAILED) {
                this.$('.zip-cancel-button').text('Close');
            } else {
                new PJQ.Loader(this.$('.zip-loader'), {
                    type: 'block'
                });
            }
        }, this));
    },
    downloadZip: function () {
        if (!this.cancel && !this.downloaded) {
            this.downloaded = true;

            this.model.download();

            if (this.options.showPromo) {
                this.renderContent();
            } else {
                this.removeModal();
            }
        }
    },
    emailChanged: function () {
        this.$('.zip-email-button').prop('disabled', this.$('.zip-email').val().indexOf('@') <= 0);
    },
    emailZip: function () {
        this.stopChecking();
        this.model.addNotification(this.$('.zip-email').val());
    },
    cancelZip: function () {
        //Clear the timeout for checking the status since we are cancelling it
        //Do this first because once its cancelled the /download endpoint will return 404
        this.stopChecking();
        if (this.model.get('status') === PJQ.constants.files.zipStatus.IN_PROGRESS) {
            //Only send the cancel request to the server if its in progress
            this.model.cancel();
        }
    },
    stopChecking: function () {
        this.cancel = true;
        if (this.checkStatusTimeout != null) {
            clearTimeout(this.checkStatusTimeout);
        }
        if (this.waitTimeout != null) {
            clearTimeout(this.waitTimeout);
        }
    }
});

PJQ.views.files.FileProgressModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-File-Progress'),
        subTemplates: {
            content: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-File-Progress-Content')
        }
    },
    events: {
        'click .file-cancel-button': 'cancelDownload'
    },
    afterRender: function () {
        this.renderContent();
    },
    renderContent: function () {
        this.renderSubTemplate(false, this.options.subTemplates.content, this.$('.modal-body'), {
            model: this.model
        }, _.bind(function () {
            new PJQ.Loader(this.$('.file-loader'), {
                type: 'block'
            });
            if (this.model.get('isReady')) {
                this.downloadFile();
            } else if (this.model.get('isProcess') && _.size(this.model.get('url')) > 0) {
                this.checkStatus();
            } else {
                this.model.convert(_.bind(function () {
                    this.downloadFile();
                }, this));
            }
        }, this));
    },
    downloadFile: function () {
        if (!this.isCancel) {
            this.model.download();
            this.removeModal();
        }
    },
    checkStatus: function () {
        setTimeout(_.bind(function () {
            this.model.checkStatus(_.bind(function (data) {
                this.model.set(data);
                if (!data.isReady) {
                    this.checkStatus();
                } else {
                    this.downloadFile();
                }
            }, this));
        }, this), 2000);
    },
    cancelDownload: function () {
        this.isCancel = true;
    }
});

PJQ.views.files.DrawingProgressModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Drawing-Progress'),
        subTemplates: {
            content: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Drawing-Progress-Content')
        },
        checkProgressInterval: 2000,
        minWaitSeconds: null
    },
    events: {
        'click .drawing-download-button': 'downloadZip',
        'click .drawing-email-button': 'emailZip',
        'keyup .drawing-email': 'emailChanged',
        'click .drawing-cancel-button': 'cancelZip'
    },
    beforeModalCreated: function () {
        if (this.options.minWaitSeconds > 0) {
            this.isWaiting = true;
            this.waitTimeout = setTimeout(_.bind(function () {
                this.isWaiting = false;
                let status = this.model.get('status');
                if (this.model.get('isReady') && (status === PJQ.constants.drawings.downloadStatus.COMPLETE)) {
                    this.downloadDrawings();
                    this.stopChecking();
                }
            }, this), this.options.minWaitSeconds * 1000);
        }
    },
    renderData: function () {
        return {
            model: this.model,
            showPromo: this.options.showPromo,
            promoType: this.options.promoType
        };
    },
    afterRender: function () {
        this.renderContent();
        this.checkDownloadStatus();
    },
    checkDownloadStatus: function () {
        let status = this.model.get('status');
        if (this.model.get('isReady') && status === PJQ.constants.drawings.downloadStatus.COMPLETE) {
            if (this.isWaiting) {
                this.renderContent();
            } else {
                this.downloadDrawings();
            }
        } else if (status === PJQ.constants.drawings.downloadStatus.QUEUED || status === PJQ.constants.drawings.downloadStatus.IN_PROGRESS) {
            this.checkStatusTimeout = setTimeout(_.bind(function () {
                this.model.fetch({
                    success: _.bind(function () {
                        this.checkDownloadStatus();
                    }, this),
                    fail: _.bind(function (model, result) {
                        this.model.set('status', PJQ.constants.drawings.downloadStatus.FAILED);
                        this.renderContent();
                        PJQ.files.logDownloadFailure({
                            model: model,
                            result: result
                        });
                    }, this)
                });
            }, this), this.options.checkProgressInterval);
        } else if (status === PJQ.constants.drawings.downloadStatus.FAILED) {
            this.renderContent();
        }
    },
    renderContent: function () {
        let defaultEmail = "";
        if (PJQ.app.session.user != null) {
            defaultEmail = PJQ.app.session.user.get('email');
        } else if (PJQ.app.session.contact != null) {
            defaultEmail = PJQ.app.session.contact.get('email');
        }
        this.renderSubTemplate(false, this.options.subTemplates.content, this.$('.modal-body'), {
            model: this.model,
            defaultEmail: defaultEmail,
            isWaiting: this.isWaiting
        }, _.bind(function () {
            if (this.model.get('status') === PJQ.constants.drawings.downloadStatus.FAILED) {
                this.$('.drawing-cancel-button').text('Close');
            }
        }, this));
    },
    downloadDrawings: function () {
        if (!this.cancel && !this.downloaded) {
            this.downloaded = true;

            this.model.download();
            if (this.options.showPromo) {
                this.renderContent();
            } else {
                this.removeModal();
            }
        }
    },
    emailChanged: function () {
        this.$('.drawing-email-button').prop('disabled', this.$('.drawing-email').val().indexOf('@') <= 0);
    },
    emailZip: function () {
        this.stopChecking();
        this.model.addNotification(this.$('.drawing-email').val());
    },
    cancelZip: function () {
        //Clear the timeout for checking the status since we are cancelling it
        //Do this first because once its cancelled the /download endpoint will return 404
        this.stopChecking();
        if (this.model.get('status') === PJQ.constants.files.zipStatus.IN_PROGRESS) {
            //Only send the cancel request to the server if its in progress
            this.model.cancel();
        }
    },
    stopChecking: function () {
        this.cancel = true;
        if (this.checkStatusTimeout != null) {
            clearTimeout(this.checkStatusTimeout);
        }
    }
});

PJQ.views.files.FileUploaderModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-Upload'),
        fileUploaderOptions: {},
        onDone: _.noop,
        maxFiles: null
    },
    events: {
        'click .btn-done': 'done'
    },
    beforeModalCreated: function () {
        this.files = new PJQ.collections.files.Files();
    },
    renderData: function () {
        return {
            options: this.options
        };
    },
    afterRender: function () {
        this.fileUploader = new PJQ.views.files.FileUploaderGrid(_.defaults({
            el: this.$('.file-uploader-container'),
            collection: this.files,
            endpoint: this.options.project != null ? PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'attachments',
                    value: this.options.folder != null ? this.options.folder.get('entryId') : null
                }
            ]) : PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'files',
                    value: this.options.folder != null ? this.options.folder.get('entryId') : null
                }
            ]),
            allowedExtensions: this.options.allowedExtensions,
            maxFiles: this.options.maxFiles,
            style: 'list',
            onSuccess: _.bind(this.dataChanged, this),
            onFileStatusChange: _.bind(this.dataChanged, this),
            onDrop: _.bind(this.dataChanged, this),
            afterDelete: _.bind(this.dataChanged, this)
        }, this.options.fileUploaderOptions));
    },
    dataChanged: function () {
        let queued = 0,
            uploading = 0,
            success = 0,
            failed = 0;
        _.each(this.files.models, function (file) {
            switch (file.get('status')) {
                case 'queued':
                    queued++;
                    break;
                case 'uploading':
                    uploading++;
                    break;
                case 'success':
                    success++;
                    break;
                case 'error':
                    failed++;
                    break;
            }

            let $queued = $('<span class="text-primary mr-2">Queued: ' + queued.toString() + '</span>');
            if (queued === 0) {
                $queued.addClass('op-6 font-weight-light');
            }

            let $uploaded = $('<span class="text-orange mr-2">Uploading: ' + uploading.toString() + '</span>');
            if (uploading === 0) {
                $uploaded.addClass('op-6 font-weight-light');
            }

            let $success = $('<span class="text-success mr-2">Uploaded: ' + success.toString() + '</span>');
            if (success === 0) {
                $success.addClass('op-6 font-weight-light');
            }

            let data;
            if (failed === 0) {
                data = [$queued, $uploaded, $success];
            } else {
                data = [$queued, $uploaded, $success, $('<span class="text-danger">Failed: ' + failed.toString() + '</span>')];
            }

            this.$('.upload-files-status').empty().append(data);
        }, this);
    },
    done: function () {
        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You cannot finish while files are still uploading.  Would you like to stop uploading?",
                isShowOkButton: false,
                isShowCancelButton: true,
                isShowSecondaryButton: true,
                secondaryButtonText: "Stop Upload",
                secondaryButtonColorClass: "danger",
                onSecondary: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
            if (typeof this.options.onDone === 'function') {
                this.options.onDone(this.files.models);
            }
        }
    },
    cancel: function () {
        this.removeModal();
    }
});

PJQ.views.files.RawFileUploaderModal = PJQ.views.files.FileUploaderModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-File-Uploader-Raw'),
        maxWidth: '530px'
    },
    events: {
        'keyup .input-revision-name': 'dataChanged',
        'click .btn-submit': 'submit'
    },
    beforeModalCreated: function () {
        if (this.options.project == null) {
            this.options.project = PJQ.app.session.project;
        }

        this.files = new PJQ.collections.files.Files();
    },
    beforeRender: function () {
        this.renderData = {
            uploadId: this.uploadId,
            options: this.options
        }
    },
    afterRender: function () {
        if (this.uploadId == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.raw-file-upload'),
                collection: this.files,
                useFileAPI: false,
                style: 'list',
                onSuccess: _.bind(this.dataChanged, this),
                onFileStatusChange: _.bind(this.dataChanged, this),
                onDrop: _.bind(this.dataChanged, this),
                afterDelete: _.bind(this.dataChanged, this)
            });
        }
    },
    dataChanged: function () {
        let hasName = _.size(this.$('.input-revision-name').val()) > 0,
            attachmentsCount = _.size(this.files.models),
            hasAttachments = attachmentsCount > 0;

        let queued = 0,
            uploading = 0,
            success = 0;
        _.each(this.files.models, function (attachment) {
            switch (attachment.get('status')) {
                case 'queued':
                    queued++;
                    break;
                case 'uploading':
                    uploading++;
                    break;
                case 'success':
                    success++;
                    break;
            }

            let $queued = $('<span class="text-primary mr-2">Queued: ' + queued.toString() + '</span>');
            if (queued === 0) {
                $queued.addClass('op-6 font-weight-light');
            }

            let $uploaded = $('<span class="text-orange mr-2">Uploading: ' + uploading.toString() + '</span>');
            if (uploading === 0) {
                $uploaded.addClass('op-6 font-weight-light');
            }


            let $success = $('<span class="text-success">Uploaded: ' + success.toString() + '</span>');
            if (success === 0) {
                $success.addClass('op-6 font-weight-light');
            }

            this.$('.upload-files-status').empty().append([$queued, $uploaded, $success]);
        }, this);
        this.$('.btn-submit').prop('disabled', !hasName || !hasAttachments || this.fileUploader.isUploading());
    },
    submit: function () {
        let postData = {
            name: this.$('.input-revision-name').val(),
            notes: this.$('.input-revision-notes').val(),
            attachments: this.files.toJSON()
        };
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'revisions'
                },
            ]),
            data: postData,
            //isApi2: true //dont do this yet
        }).post().done(_.bind(function (data) {
            this.uploadId = data.uploadId;
            if (this.options.project != null) {
                this.options.project.set('status', 'BUSY');
            }
            this.render();
        }, this)).fail(_.bind(function (xhr, err, result) {
            this.uploadId = 0;
            this.render();
            new PJQ.logging.Debug(PJQ.logging.LoggingActions.UPLOAD_RAW_FILES, {
                data: postData,
                error: err,
                result: result
            });
        }, this));
    }
});

PJQ.views.files.FileUploaderBackground = PJQ.views.files.FileUploader.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-Grid'),
        subTemplates: {
            gridFile: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-Grid-File'),
            listFile: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Uploader-List-File')
        },
        style: 'grid',
        isSmall: false, //this is used when the uploader is in a small location so the elements/text sizes need to be smaller
        endpoint: "/files",
        canUpload: true,
        canDelete: true,
        canView: true,
        dictRemoveFile: "Delete",
        isRemoveOnComplete: false,
        allowedExtensions: null,
        dictDefaultMessage: "Drop files here or click to upload",
        parallelUploads: 1,
        chunking: true,
        onError: _.noop,
        onSuccess: _.noop,
        onFileStatusChange: _.noop,
        onDrop: _.noop,
        onDelete: null, //this must be null or correctly use the callback (2nd param)
        afterDelete: _.noop,
        previewImageDimension: 160,
        showCreatedByLink: true,
        useFileAPI: true,
        hasNotes: false,
        isVersioned: false
    },
    events: {
        'click .file-preview-image': 'viewFile',
        'click .file-preview-download': 'downloadFile',
        'click .file-preview-delete': 'deleteFile',
        'click .file-preview': 'renderHistoryFiles'
    },
    beforeFirstRender: function () {
        if (this.collection == null) {
            this.collection = new PJQ.collections.files.Files();
        }
    },
    renderDropzone() {
        if (this.options.isSmall) {
            this.$('.file-upload').addClass('file-upload-small');
        }

        if (this.options.style.toLowerCase() === 'list') {
            this.$('.file-upload').addClass('file-upload-list');
        } else {
            this.$('.file-upload').addClass('file-upload-grid');
        }

        this.dropzone = new Dropzone('#fileUpload_' + this.options.uuid, _.extend(this.options.dropzoneOptions, {
            addedfile: _.bind(function (file) {
                let fileModel = new this.collection.model({
                    name: file.name,
                    status: 'queued'
                });

                if (PJQ.app.session.contact != null) {
                    fileModel.set('createdBy', PJQ.app.session.contact.toJSON());
                } else if (PJQ.app.session.user != null) {
                    fileModel.set('createdBy', PJQ.app.session.user.toJSON());
                }

                fileModel.file = file;
                file.model = fileModel;
                this.collection.add(fileModel);
                file.$previewElement = this.renderFile(fileModel, this.options.style.toLowerCase() === 'grid');
                file.$previewElement.addClass('uploading queued');
                file.previewElement = file.$previewElement[0];
            }, this),
            thumbnail: function (file, dataUrl) {
                if (file.$previewElement != null) {
                    file.$previewElement.find('.file-preview-image').attr('src', dataUrl);
                }
            },
            uploadprogress: function (file, progress) {
                file.$previewElement.removeClass('queued');

                if (file.model.get('status') !== file.status) {
                    file.model.set('status', file.status);
                    this.options.onFileStatusChange(file);
                }

                //This is a fix for chunking progress
                //Dropzone triggers a progress event for the end of a chunk w/ a progress of 100%
                //We want to ignore all progress events that are not related to the total upload progress of this file
                if ((file.status === 'uploading' && progress < 100) || file.status === 'success') {
                    file.lastProgress = Math.ceil(progress);
                    let width = file.lastProgress.toString() + '%';
                    file.$previewElement.find(".file-preview-progress .progress-bar").css('width', width).html(width);
                }
            },
            drop: _.bind(function () {
                if (typeof this.options.onDrop === 'function') {
                    this.options.onDrop();
                }
            }, this),
            complete: _.bind(function (file) {
                if (file.status === 'success') {
                    file.$previewElement.removeClass('uploading').addClass('uploaded');

                    file.model.dataUrl = file.dataURL;
                    let response = JSON.parse(file.xhr.response);
                    if (this.options.useApiV2) {
                        file.model.set({
                            uploadId: response.uploadId,
                            name: response.fileName
                        }, {
                            silent: true
                        });
                    } else {
                        file.model.set({
                            folder: response.folder,
                            name: response.fileData.fileName
                        }, {
                            silent: true
                        });
                    }

                    if (!this.options.useApiV2 && this.options.endpoint !== '/files') {
                        let fileResponse;
                        if (PJQ.helpers.objectHelpers.refinedType(response) === 'array') {
                            _.each(response, function (responseFile) {
                                if (responseFile.isFolder) {
                                    this.collection.add(responseFile);
                                } else {
                                    fileResponse = responseFile;
                                }
                            }, this);
                        } else {
                            fileResponse = response;
                        }
                        file.model.set(fileResponse, {
                            silent: true
                        });
                    }

                    if (file.model.id > 0) {
                        file.$previewElement.find('.file-preview-download').removeClass('hidden');
                    }

                    this.onSuccess(file);
                } else if (file.status === 'error') {
                    if (_.size(this.options.dropzoneOptions.acceptedFiles) > 0 && !_.contains(this.options.dropzoneOptions.acceptedFiles, function (extension) {
                        return file.name.toLowerCase().indexOf(extension);
                    })) {
                        this.removeFile(file);
                        this.showError('The file type you uploaded is not allowed');
                    } else {
                        let retries = file.model.get('retries');
                        retries = retries != null ? retries : 0;
                        if (retries > -1) {
                            file.$previewElement.removeClass('uploading').addClass('failed');
                        } else {
                            file.model.set('retries', 1);
                            new File([file], file.name, {type: file.type});
                            this.dropzone.uploadFile(file);
                        }
                    }
                }
            }, this)
        }));

        if (!this.options.canUpload) {
            this.$(".dz-hidden-input").remove();
        }

        this.renderFiles();
    },
    renderFiles() {
        if (this.options.canUpload) {
            this.renderUploadMessage();
        }

        _.each(_.sortBy(_.filter(this.collection.models, function (model) {
            return !model.get('isDeleted');
        }), function (model) {
            return -model.get('entryId');
        }), _.bind(function (model) {
            this.renderFile(model);
        }, this));
        PJQ.app.lazyLoad().update();
    },
    renderFile(file, isPrepend = false) {
        let fileTemplate;
        if (this.options.style.toLowerCase() === 'list') {
            fileTemplate = this.options.subTemplates.listFile;
        } else {
            fileTemplate = this.options.subTemplates.gridFile;
        }
        let $fileEl = PJQ.templating.TemplateRenderer.parseTemplate(fileTemplate, {
            model: file,
            showCreatedByLink: this.options.showCreatedByLink,
            canDelete: this.options.canDelete,
            canView: this.options.canView,
            isImage: file.isImage(),
            thumbUrl: file.thumbnailUrl(),
            previewImageDimension: this.options.previewImageDimension,
            hasNotes: this.options.hasNotes,
            isVersioned: this.options.isVersioned,
            versions: file.fileHistory ? file.fileHistory : null
        });
        if (this.options.canUpload && !this.$('.dz-message').hasClass('dz-message-top')) {
            $fileEl.addClass('hidden');
            this.renderUploadMessage(_.bind(function () {
                $fileEl.removeClass('hidden');
            }, this));
        }

        let $outer;
        if (this.options.sideBySide && file.id > 0) {
            $outer = this.$('.files-existing-container');
        } else {
            $outer = this.$('.files-container');
        }
        if (isPrepend) {
            $outer.prepend($fileEl);
        } else {
            $outer.append($fileEl);
        }
        return $fileEl;
    },
    renderUploadMessage: function (callback = _.noop) {
        let $message = this.$('.dz-message'),
            topClass = 'dz-message-top',
            topCSS = {
                height: '40px'
            };

        let hasNewAttachment = this.collection.findWhere(function (attachment) {
            return attachment.isNew();
        }) != null;
        if (hasNewAttachment) {
            this.$('.file-upload').removeClass('dz-clickable');
            if (!$message.hasClass('dz-message-top')) {
                $message.addClass(topClass).animate(topCSS, 500, _.bind(function () {
                    $message.css(topCSS).html('Drop files or <a href="javascript:void(0)" class="file-upload-upload ml-1 text-orange">click here to upload</a>');
                    if (callback != null) {
                        callback();
                    }
                }, this)).addClass(topClass);
            } else {
                callback();
            }
        } else {
            $message.html('Drop files or click to upload');
            if (callback != null) {
                callback();
            }
        }
    },
    viewFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));
        PJQ.app.view.renderPhotoViewer({
            model: file,
            collection: this.collection
        });
    },
    downloadFile: function (e) {
        let file = this.collection.get($(e.currentTarget).closest('.file-preview').data('cid'));
        file.download();
    },
    deleteFile: function (e) {
        let previewContainer = $(e.currentTarget).closest('.file-preview'),
            file = this.collection.get(previewContainer.data('cid'));
        if (typeof this.options.onDelete === 'function') {
            this.options.onDelete(file, _.bind(function () {
                previewContainer.remove();
                this.options.afterDelete();
            }, this));
        } else {
            file.destroy();
            previewContainer.remove();
            this.options.afterDelete();
        }
    }
});

PJQ.views.files.FileSelectInput = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Select-Input'),
        subTemplates: {
            changeButton: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'File-Select-Input-Change-Button')
        },
        isShowChangeButton: false,
        emptyNotice: "No Files Selected"
    },
    events: {
        "click .file-select-input-edit": "edit"
    },
    beforeFirstRender() {
        if (this.options.isShowChangeButton) {
            this.options.template = this.options.subTemplates.changeButton;
        }

        let addButton = $('<button type="button" class="btn btn-transparent-light text-info btn-sm file-select-input-edit ml-1"><i class="fal fa-pencil"></i></button>');
        this.$el.closest('.form-group').find('label').append(addButton);
        addButton.on('click', _.bind(this.edit, this));

        this.selectedFiles = this.options.selectedFiles ? this.options.selectedFiles : [];
    },
    renderData: function () {
        return {
            selectedFiles: this.selectedFiles
        };
    },
    edit: function () {
        new PJQ.views.files.FileSelector(_.defaults(this.options.selectorOptions, {
            project: this.options.project,
            selectedAttachmentIds: _.map(this.selectedFiles, function (file) {
                return file.cid;
            }),
            collection: this.options.collection,
            onSave: _.bind(function (files) {
                this.selectedFiles = this.options.ignoreFolders ? _.filter(files, function (file) {
                    return !file.get('isFolder')
                }) : files;

                this.render();

                if (typeof this.options.onChange === 'function') {
                    this.options.onChange(this.selectedFiles);
                }
            }, this)
        }));
    },
    validate: function () {
        if (_.size(this.selectedFiles) > 0) {
            return true;
        } else {
            this.$('.file-select-value').html('<div class="text-danger mt-1">This field is required.</div>');
            return false;
        }
    }
});

PJQ.views.files.FileVersionsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-file-versions'),
        width: '40%',
        maxWidth: 800,
    },
    events: {
        'click .btn-download-version': 'downloadVersion',
        'click .btn-save': 'save'
    },
    beforeRender: function () {
        this.versions = _.union(this.model.versions ? this.model.versions.models : [], [this.model]);

        if (this.collectionDefinition == null) {
            this.collectionDefinition = PJQ.collections.files.Files;
        }

        this.newVersions = new this.collectionDefinition();

        this.renderData = {
            model: this.model
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".file-versions"),
            data: this.versions,
            isHideSearch: true,
            rowId: "cid",
            paging: false,
            order: [0, 'desc'],
            language: {
                zeroRecords: 'No other versions'
            },
            columns: [
                {
                    "title": "Version",
                    "data": "attributes.version",
                    "render": function (data, type, row) {
                        return data ?? 1;
                    }
                },
                {
                    "title": "Name",
                    "data": "attributes.name"
                },
                {
                    "title": "Uploaded",
                    "data": "attributes.createdOn",
                    "render": function (data, type, row) {
                        if (row.get('createdOn') == null) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(row.get('createdOn'), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": '80px',
                    "render": _.bind(function (data, type, row) {
                        return '<div class="show-on-row-hover"><button type="button" data-cid="' + row.cid + '" class="btn btn-primary btn-download-version"><i class="fal fa-download"></i></button></div>';
                    }, this)
                }
            ]
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.file-versions-uploader'),
            collection: this.newVersions,
            style: 'list',
            canUpload: this.newVersions.length === 0,
            canDelete: true,
            canDownload: true,
            isRemoveOnComplete: true,
            previewImageDimension: 150,
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    downloadVersion: function (e) {
        let file = _.findWhere(this.versions, {cid: $(e.currentTarget).data('cid')});
        file.download();
    },
    save: function () {
        _.each(this.newVersions.models, (newFile) => {
            newFile.set({
                parentAttachmentId: this.model.get('attachmentId'),
                version: this.versions.length + 1,
                createdOn: new Date()
            });
            this.model.versions.add(newFile);
        });

        this.options.onSave(this.newVersions.models);
        this.removeModal();
    }
});

PJQ.helpers.fileHelpers = {
    getExtension: function (filename) {
        return filename ? filename.split('.').pop().toLowerCase() : null;
    },
    getDisplayFileSize(bytes, si = true) {
        let thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        let units = si
                ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'],
            u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }
};

PJQ.modules.files = {
    routes: [
        {
            route: 'files/share/:accessKey',
            name: 'shareFiles',
            callback: function (accessKey) {
                let files = new PJQ.collections.files.FileShare(null, {
                    accessKey: accessKey
                });
                files.fetch({
                    success: function () {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'orders'
                                },
                                {
                                    endpoint: 'settings'
                                }
                            ], [
                                {
                                    parameter: 'entryId',
                                    value: files.models[0].get('entryId')
                                }
                            ])
                        }).get().done(_.bind(function (settings) {
                            let $container = $('<div>', {
                                class: 'p-3'
                            });
                            PJQ.app.$el.html($container);
                            _.each(files.models, function (attachment) {
                                if (attachment.get('isFolder'))
                                    attachment.isFetched = true;
                            });

                            PJQ.app.view.renderView(PJQ.views.projects.Attachments, {
                                el: $container,
                                collection: files,
                                isAdmin: false,
                                orderSettings: settings
                            });
                        }, this));

                    },
                    error: function (data, response) {
                        let $container = $('<div>', {
                            class: 'p-3'
                        });
                        PJQ.app.$el.html($container);
                        if (response.responseJSON.message == 'BUSY') {
                            $container.html(`
                                <div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
                                    <div>
                                        <div><i class="fal fa-circle-exclamation fa-9x text-orange mb-2"></i></div>
                                        <div class="fs-36">File Share Unavailable</div>
                                        <div class="fs-24">Files for this project are currently being processed.<br />Please try again later.</div>
                                    </div>
                                </div>
						    `);
                        } else if (response.responseJSON.message == 'OFFLINE') {
                            $container.html(`
                                <div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
                                    <div>
                                        <div><i class="fal fa-circle-exclamation fa-9x text-orange mb-2"></i></div>
                                        <div class="fs-36">File Share Unavailable</div>
                                        <div class="fs-24">This project is currently unavailable for download.<br />Please try again later, or check with the sender if the issue persists.</div>
                                    </div>
                                </div>
						    `);
                        } else {
                            $container.html(`
                                <div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
                                    <div>
                                        <div><i class="fal fa-clock fa-9x text-orange mb-2"></i></div>
                                        <div class="fs-36">File Share Invalid</div>
                                        <div class="fs-24">This file share has expired or is invalid.</div>
                                    </div>
                                </div>
						    `);
                        }
                    }
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.files.routes);